import React, { useState } from 'react';
import { useMutation, gql } from '@apollo/client';

const FORGOT_PASSWORD_MUTATION = gql`
  mutation Mutation($email: String!) {
  requestPasswordReset(email: $email)
}
`;


const ForgotPasswordForm = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const [forgotPassword, { loading }] = useMutation(FORGOT_PASSWORD_MUTATION, {
    onCompleted: () => setSubmitted(true),
    onError: (err) => setError(err.message),
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    forgotPassword({ variables: { email } });
  };

  return (
    <div className="forgot-password-form" style={{ color: 'white', maxWidth: 400, margin: '0 auto' }}>
      <h2>Forgot Password</h2>
      {submitted ? (
        <p>✅ If an account with that email exists, a reset link has been sent.</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{ width: '100%', padding: 10, marginBottom: 10 }}
          />
          <button type="submit" disabled={loading} style={{ padding: '10px 20px' }}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </form>
      )}
    </div>
  );
};

export default ForgotPasswordForm;
